module.exports = __webpack_public_path__ + "static/media/step-indicator-3.72547e54.svg";